
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class TileRow extends Vue {
  @Prop(String) readonly title!: string;
  @Prop(String) readonly content!: boolean;
}
